import {
  BRANDING_CACHE_TTL_MS,
  DEFAULT_BRANDING_CONFIG,
} from "../constants/defaultBranding";
import type { BrandingConfig, CachedBrandingConfig } from "../types";
import { normalizeBrandingConfig } from "./normalizeBranding";

const CACHE_KEY_PREFIX = "BRANDING_CONFIG";

export function getBrandingCacheKey(hostname = window.location.hostname): string {
  return `${CACHE_KEY_PREFIX}_${hostname}`;
}

export function readBrandingConfigCache(): BrandingConfig | null {
  try {
    const raw = localStorage.getItem(getBrandingCacheKey());
    if (!raw) return null;

    const cached = JSON.parse(raw) as Partial<CachedBrandingConfig>;
    if (!cached.expiresAt || cached.expiresAt <= Date.now()) {
      clearBrandingConfigCache();
      return null;
    }

    return normalizeBrandingConfig(cached.value);
  } catch {
    clearBrandingConfigCache();
    return null;
  }
}

export function writeBrandingConfigCache(config: BrandingConfig): void {
  try {
    const cached: CachedBrandingConfig = {
      value: normalizeBrandingConfig(config),
      expiresAt: Date.now() + BRANDING_CACHE_TTL_MS,
    };
    localStorage.setItem(getBrandingCacheKey(), JSON.stringify(cached));
  } catch {
    // Cache is optional. Ignore storage quota and privacy mode errors.
  }
}

export function clearBrandingConfigCache(): void {
  try {
    localStorage.removeItem(getBrandingCacheKey());
  } catch {
    // Cache is optional.
  }
}

export function resetBrandingConfigCache(): BrandingConfig {
  clearBrandingConfigCache();
  return DEFAULT_BRANDING_CONFIG;
}
